import { format } from "date-fns";
import { toZonedTime } from 'date-fns-tz';
import { COMMON_OPTIONS, DATE_FORMAT } from "../const/const";


export const customFormatDate = (date: Date, dateFormat: string = DATE_FORMAT, options: any = COMMON_OPTIONS) => {
    if (!date) return '- - -';
    const zonedDate = toZonedTime(date, 'America/Bogota');
    return format(zonedDate, dateFormat, options);
}